module.exports = __webpack_public_path__ + "static/media/galerija_2017 (38).3ab8a6dc.jpg";